module.exports = __webpack_public_path__ + "img/lg_ring_r_i_0_0.74922187.png";